/* eslint-disable */
export default {
  today: 'Oggi',
  yesterday: 'Ieri',
  empty: 'Nessuna registrazione chiamata',
} as const;

// @key: @#@"today"@#@ @source: @#@"Today"@#@
// @key: @#@"yesterday"@#@ @source: @#@"Yesterday"@#@
// @key: @#@"empty"@#@ @source: @#@"No call records"@#@
